import { skills } from '../data/content';
import { SectionHeading } from './SectionHeading';

export function Skills() {
  return (
    <section className="section-band" id="skills">
      <div className="container">
        <SectionHeading
          eyebrow="Skills"
          title="Languages and Code"
          text="I've kept only what you specified: C#, HTML, CSS, JavaScript, and Python."
        />

        <div className="skills-grid">
          {skills.map((skill) => (
            <article className="skill-card reveal" key={skill.name}>
              <div className="skill-topline">
                <h3>{skill.name}</h3>
                <span>{skill.group}</span>
              </div>
              <div className="progress-shell" aria-label={`${skill.name} ${skill.level}%`}>
                <span style={{ width: `${skill.level}%` }} />
              </div>
              <strong>{skill.level}%</strong>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
